export function formatArbn(arbn: string | undefined | null) {
    if(arbn == null || arbn.length !== 9) {
        return arbn;
    }

    const [a, b, c, d, e, f, g, h, i] = arbn.split('');

    return `${a}${b}${c} ${d}${e}${f} ${g}${h}${i}`;
}